/**
 * Shared onboarding / welcome path configuration.
 * Used by login status redirects and OTP post-verification navigation.
 * Paths are locale-agnostic; EN/AR (incl. RTL) use the same routes via i18n/dir.
 */
export const WELCOME_BASE_PATH = "/welcome-to-datatram";

export const WELCOME_PATHS = {
  basicInformation: `${WELCOME_BASE_PATH}/basic-information`,
  dataLoading: `${WELCOME_BASE_PATH}/data-loading`,
  connectSources: `${WELCOME_BASE_PATH}/connect-sources`,
} as const;

/** Onboarding statuses from `tenant-login` (not yet `status: true`). */
export const WELCOME_ROUTES_BY_STATUS: Record<
  number,
  { pathname: string; state: { currentStep: number } }
> = {
  2: {
    pathname: WELCOME_PATHS.basicInformation,
    state: { currentStep: 0 },
  },
  3: {
    pathname: WELCOME_PATHS.dataLoading,
    state: { currentStep: 2 },
  },
  4: {
    pathname: WELCOME_PATHS.connectSources,
    state: { currentStep: 1 },
  },
};

/** Destination after successful OTP verification (`ProtectedRoute` requires `from: "welcome"`). */
export const OTP_POST_VERIFY_NAVIGATION = {
  pathname: WELCOME_PATHS.basicInformation,
  state: { from: "welcome" as const },
};
